module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAAAU0lEQVRIDWNkIAJITPj/H5uyFwWMjNjEkcWYkDm0YI9aQDBUR4No4IOIEVcmIug0IhWMRjLBgBr6QUSwuAWFAa6UNlpcE0whxCgY+qlo1AcE4xkAcmkK1PAPuS8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/icons/guanzuj@3x.png
// module id = kgHq
// module chunks = 1